import { Resourceful, Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { ScreenProtocolScope, ScreenProtocol } from "../../ScreenProtocol";
import { LogGroup } from "../.././MyHelpers";
import { BonusFinish, IBonusStartConfig } from "../SlotGame";
import { SlotBonusParams } from "./SlotBonusParams";

export abstract class SlotBonus3 implements Resourceful2
{
	protected gameName: string = "";
	protected bonusName: string = "";
	protected logGroup: LogGroup = null;

	// resource identifier to prevent resource clash
	protected parentresid: ResourceIdentifier = null;
	protected resid: ResourceIdentifier = null;
	protected classid: string = "";


	protected screenProtocolScope: ScreenProtocolScope = null;
	protected screenProtocol: ScreenProtocol = null;

	public constructor(gameName: string, params: SlotBonusParams) {
		this.gameName = gameName;
		this.bonusName = this.BonusName();

		this.parentresid = params.resid;
		this.resid = params.resid.Add(this.bonusName + "3");
		this.logGroup = params.logGroup.Add(this.bonusName + "3");

		this.screenProtocolScope = params.screenProtocolScope.Add(this.bonusName);

		this.screenProtocol = params.screenProtocol;
	}

	protected abstract BonusName(): string;

	public abstract ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>;

	public abstract PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>;


	// notify bonus, that trigger animation has started
	public TriggerAnimationStarted(): void {}
	public TriggerAnimationStopped(): void {}

	// messages from backend

	// signal, that bonus has finished
	public abstract OnBonusFinish(bonusFinish: BonusFinish): void;

	public abstract Prepare(bonusStartConfig: IBonusStartConfig): void;
	public abstract Hide():void;
	public abstract Show():void;
	public abstract Update():void;

	public abstract View():HTMLElement;

	public abstract Start():void;
	public abstract Stop():void;

	public abstract Reset(): void;
}